<template>
  <div class="choose-city">
    <el-select
      :value="city"
      @change="goToSubdomain"
      placeholder="城市"
      filterable
      :required="true"
    >
      <el-option
        v-for="c in cities"
        :key="c.id"
        :label="c.name"
        :value="c.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState(["cities", "city"])
  },
  methods: {
    ...mapMutations([
      "setCities",
      "setCity",
      "goToSubdomain",
    ]),
    setCityFromUrl: function () {
      var cityIds = this.cities.map(function (c) {
        return c.id;
      });
      let s = location.hostname.split(".99huaren");
      if (localStorage.getItem("city") !== s[0] && cityIds.includes(s[0])) {
        localStorage.setItem("city", s[0]);
      }
      this.setCity(s[0]);
    }
  },
  mounted: function () {
    if (!this.cities) {
      this.$axios.get("/cities").then(res => {
        this.setCities(res.data);
        this.setCityFromUrl();
      });
    } else {
      this.setCityFromUrl();
    }
  }
};
</script>

<style scoped>
.desktopView.choose-city {
  width: 107px;
}
</style>
